export const formatTickerExchange = (exchange?: string, otcTier?: string): string => {
  if (exchange === 'OTC' && otcTier) {
    return exchange + otcTier;
  }

  return exchange ?? '';
};
